__webpack_require__.p = "/wp-content/themes/headlesstheme/sushi-shogun/dist/";